/* eslint arrow-body-style: 0 */
import DashboardEmbedView from './components/DashboardEmbedView.vue';
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/dashboard_embed'),
    name: 'dashboard_embed',
    roles: ['administrator', 'agent'],
    component: DashboardEmbedView,
  }
];
